import { GET_CLIENT_ADVISOR, GET_REPORT } from "../actions/types";

const initialState = {
  talentData: {
    stat: {},
    revenue: {},
  },
  companyData: {
    stat: {},
    revenue: {},
  },
  opportunityData: {},
  algoData: {},
  reportData: null,
};

const dashboardDataReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_CLIENT_ADVISOR:
      return {
        ...state,
        talentData: {
          stat: payload?.talent?.stat || {},
          revenue: payload?.talent?.reveneue || {},
        },
        companyData: {
          stat: payload?.company?.stat || {},
          revenue: payload?.company?.revenue || {},
        },
        opportunityData: payload?.opportunities?.stat || {},
        algoData: payload?.algo?.stat || {},
      };

    case GET_REPORT:
      return {
        ...state,
        reportData: payload,
      };

    default:
      return state;
  }
};

export default dashboardDataReducer;
